import React, { useState } from 'react'
import { Button } from '@instacart/tds'
import { LockedIcon } from '@instacart/ids-core'
import FocusLock from 'react-focus-lock'
import kdsLockStore from '../../Stores/KdsLockStore'
import styles from './KdsLockedOverlay.module.scss'

type UnlockState = 'idle' | 'unlocking' | 'failed'

export const KdsLockedOverlay = () => {
  const [unlockState, setUnlockState] = useState<UnlockState>('idle')
  const unlocking = unlockState === 'unlocking'

  const unlock = async () => {
    setUnlockState('unlocking')
    try {
      const unlocked = await kdsLockStore.unlock()
      if (!unlocked) {
        setUnlockState('idle')
      }
    } catch {
      setUnlockState('failed')
    }
  }

  return (
    <FocusLock>
      <div
        className={styles.overlay}
        role="dialog"
        aria-modal="true"
        aria-labelledby="kds-locked-title"
        data-testid="kds-locked-overlay"
      >
        <div className={styles.panel}>
          <span className={styles.icon}>
            <LockedIcon />
          </span>
          <h2 id="kds-locked-title" className={styles.title}>
            KDS locked
          </h2>
          <p className={styles.subtitle}>Unlock to resume using this display.</p>
          <Button variant="primary" onClick={() => void unlock()} disabled={unlocking}>
            {unlocking ? 'Unlocking...' : 'Unlock KDS'}
          </Button>
          {unlockState === 'failed' && (
            <p className={styles.error} role="alert">
              Unable to unlock. Please try again.
            </p>
          )}
        </div>
      </div>
    </FocusLock>
  )
}
